import React from "react";

const Findout = () => {
  return (
    <>
      <div className="findoutcontainer">
        <div className="findouttext">
          Find out more <br /> about how we work
        </div>
        <div className="workbutton">How we work</div>
      </div>
    </>
  );
};

export default Findout;
